import { GameLiveConnection } from '../../../services/liveConnection';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { handBlackJackGameService } from '../handBlackjackService/gameService';
import { environmentBuilder } from '../../../core/helpers/environmentBuilder';
import { detectSocketPath } from '../../../core/constants/socketPathName';
import { SOCKET_DECISIONS_METHODS } from '../handBlackjackCore/constants';
import { SOCKET_METHODS } from '../../blackjack/blackJackCore/constants';

export class HandBlackJackGameConnection extends GameLiveConnection {
  sendDecisionAction(target, params) {
    mainGameConnection.invoke(target, params).then(() => {});
  }

  sendInsurance(data) {
    mainGameConnection.invoke(SOCKET_METHODS.INSURANCE, data).then(() => {});
  }

  executeGameConnections() {
    mainGameConnection.onDoSpinResult(
      handBlackJackGameService.handleDoSpinResult.bind(handBlackJackGameService)
    );
    mainGameConnection.on(
      SOCKET_METHODS.CARD_RESULT,
      handBlackJackGameService.handleCardResult.bind(handBlackJackGameService)
    );
    mainGameConnection.on(
      SOCKET_METHODS.DECISION_RESULT,
      handBlackJackGameService.handleDecisionResult.bind(handBlackJackGameService)
    );
    mainGameConnection.on(
      SOCKET_METHODS.SPIN_RESULT,
      handBlackJackGameService.handleSpinResult.bind(handBlackJackGameService)
    );
    mainGameConnection.onGetInitialStateResult(
      handBlackJackGameService.onGetInitialStateResult.bind(handBlackJackGameService)
    );
    Object.values(SOCKET_DECISIONS_METHODS).forEach((method) => {
      mainGameConnection.on(method, (data) =>
        handBlackJackGameService.handleDecisionEvents.bind(handBlackJackGameService)(method, data)
      );
    });
  }
}

const { socketUrl } = environmentBuilder(detectSocketPath(window.location.pathname));

export const handBlackJackGameConnection = new HandBlackJackGameConnection({
  url: `${socketUrl}game`,
});
